module.exports = "/assets/data/648ab4bd933193ab0e8ed6fc0ef29057-BN20.data.json";